import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAccessKey } from "./baseQuery";

export const adApi = createApi({
  reducerPath: "adApi",
  baseQuery: baseQueryWithAccessKey,
  tagTypes: ["ad-list", "ad-set-list", "ad-accounts"],
  endpoints: (builder) => ({
    getAdStats: builder.query({
      query: (params) => ({
        url: "/api/glabp/",
        params,
      }),
    }),
    getSingleAdStats: builder.query({
      query: ({ glid, chart_type }) => ({
        url: "/api/glabp/",
        params: { page: "ChartData", glid, chart_type },
      }),
    }),
    getAllAdList: builder.query({
      query: () => ({
        url: "/api/glabp/",
        params: { page: "AdProject_All" },
      }),
      providesTags: ["ad-list"],
    }),
    getAllAdAccounts: builder.query({
      query: () => ({
        url: "/api/glabp/",
        params: { page: "AdAccount_All" },
      }),
      providesTags: ["ad-accounts"],
    }),
    getAllAdSets: builder.query({
      query: () => ({
        url: "/api/glabp/",
        params: { page: "AdSet_All" },
      }),
      providesTags: ["ad-set-list"],
    }),
    updateAdSet: builder.mutation({
      query: (payload) => ({
        url: "/api/glabp/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["ad-set-list"],
    }),
    searchInterests: builder.query({
      query: ({ query, ad_account_id }) => ({
        url: "/api/adset-search-interest",
        params: { query, ad_account_id },
      }),
    }),
    updateAd: builder.mutation({
      query: (payload) => ({
        url: "/api/glabp/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["ad-list", "ad-set-list"],
    }),
    updateAdAccount: builder.mutation({
      query: (payload) => ({
        url: "/api/glabp/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["ad-accounts"],
    }),
  }),
});

export const {
  useGetAdStatsQuery,
  useGetSingleAdStatsQuery,
  useGetAllAdListQuery,
  useUpdateAdMutation,
  useGetAllAdSetsQuery,
  useUpdateAdSetMutation,
  useSearchInterestsQuery,
  useGetAllAdAccountsQuery,
  useUpdateAdAccountMutation,
} = adApi;
